<div>
    <a class="dropdown-item py-1 px-3" href="javascript:;">
        <p-radioButton name="customerMode" data-color="light" [(ngModel)]="isColor" value="light" label="default "
            class="pr-2">
        </p-radioButton>
    </a>
    <a class="dropdown-item py-1 px-3 cursor-pointer">
        <p-radioButton name="customerMode" data-color="dark" [(ngModel)]="isColor" value="dark" label="dark "
            class="pl-2">
        </p-radioButton>
    </a>
    <!-- <a class="dropdown-item py-1 px-3 cursor-pointer">
      <p-radioButton name="customerMode" (click)="customerModeChanged('custom')" [(ngModel)]="isColor" value="custom"
        label="custom" class="pl-2">
      </p-radioButton>
    </a> -->
    <div class="tools" *ngIf="isColor==='custom'">
        <p class="px-1 mb-0">header</p>
        <label for="color-picker-primary" class="px-2">Primary colour</label>
        <input type="color" id="color-picker-background" value="#b30027" (change)='headerBackground($event)'>
        <label for="color-picker-contrast" class="px-2">Contrast colour</label>
        <input type="color" id="color-picker" value="#ffffff" (change)='headerColor($event)'>
        <p class="px-1 mb-0">aside</p>
        <label for="color-picker-primary" class="px-2">Primary colour</label>
        <input type="color" id="color-picker-background" value="#b30027" (change)='asideBackground($event)'>
        <label for="color-picker-contrast" class="px-2">Contrast colour</label>
        <input type="color" id="color-picker" value="#ffffff" (change)='asideColor($event)'>
        <p class="px-1 mb-0">content</p>
        <label for="color-picker-primary" class="px-2">Primary colour</label>
        <input type="color" id="color-picker-background" value="#b30027" (change)='contentBackground($event)'>
        <label for="color-picker-contrast" class="px-2">Contrast colour</label>
        <input type="color" id="color-picker" value="#ffffff" (change)='contentColor($event)'>
        <p class="px-1 mb-0">list</p>
        <label for="color-picker-primary" class="px-2">Primary colour</label>
        <input type="color" id="color-picker-background" value="#b30027" (change)='listBackground($event)'>
        <label for="color-picker-contrast" class="px-2">Contrast colour</label>
        <input type="color" id="color-picker" value="#ffffff" (change)='listColor($event)'>
    </div>
</div>